export default "/address.dbc6fc5f-cf43d9.png";